export default "__VITE_ASSET__D7wWu5Mp__"